import { Dayjs } from 'dayjs';

function formatDate(date: Date): string {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

function getOneYearAgo(date: Date): Date {
  const oneYearAgo = new Date(date);
  oneYearAgo.setFullYear(oneYearAgo.getFullYear() - 1);
  return oneYearAgo;
}

const today = new Date();
const oneYearAgoDate = getOneYearAgo(today);

const formatDayjsDate = (date: Dayjs | null): string => {
  return date ? date.format('YYYY-MM-DD') : '';
};

export default {
  startedDate: oneYearAgoDate,
  endedDate: formatDate(today),
  formatDayjsDate: formatDayjsDate,
};
